function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { ConfirmationModal, MenuItem, Select, Spinner, Typography } from 'seagull';
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import { useOverlayContext, useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import styles from "./RemoveFromTeamModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const commonModalProps = {
  title: 'Remove team member',
  skin: 'danger',
  primaryButtonLabel: 'Remove team member',
  secondaryButtonLabel: 'Cancel'
};
export default function RemoveFromTeamModal(props) {
  const {
    member,
    dismissModal
  } = props;
  const {
    api
  } = useStoreActions();
  const onClose = () => dismissModal();
  return /*#__PURE__*/_jsx(RestfulWrapper, {
    fetch: () => api.member.getAssignedRelationships(member.id()),
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/_jsx(RemoveFromTeamModalWithData, _objectSpread(_objectSpread({}, props), {}, {
        numAssignedRelationships: data
      }));
    },
    renderLoader: () => /*#__PURE__*/_jsx(ConfirmationModal, _objectSpread(_objectSpread({}, commonModalProps), {}, {
      content: /*#__PURE__*/_jsx(Spinner, {}),
      primaryButtonDisabled: true,
      onCloseButtonClick: onClose,
      onSecondaryButtonClick: onClose
    }))
  });
}
function RemoveFromTeamModalWithData(props) {
  const {
    member,
    allMembers,
    numAssignedRelationships,
    onRefresh,
    dismissModal
  } = props;
  const isVendor = useStore(selectors.user.isVendor);
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      memberIdToReassign: ''
    }
  });
  const hasAssignedRelationships = !!numAssignedRelationships;
  const onClose = () => dismissModal();
  const optionsToReassign = useMemo(() => {
    return allMembers.filter(m => m.id() !== member.id() && m.isAssignable(isVendor)).map(m => ({
      id: m.id(),
      text: m.fullName()
    }));
  }, [allMembers, member, isVendor]);
  const onRemove = async _ref2 => {
    let {
      memberIdToReassign
    } = _ref2;
    const onRemoveLoader = 'rmMember';
    overlayContext.startLoader(onRemoveLoader);
    try {
      if (hasAssignedRelationships) {
        await api.member.reassignAllRelationships({
          assignedUser: member.id(),
          assignToUser: memberIdToReassign
        });
      }
      await api.member.remove({
        id: member.id(),
        currentRole: member.effectiveRole()
      });
      logBI(12203, {
        id: member.id(),
        email: member.email(),
        reassignTo: memberIdToReassign
      });
    } catch (err) {
      overlayContext.showErrorToast('Failed to remove team member', 'rm-member-fail');
      return overlayContext.stopLoader(onRemoveLoader);
    }
    try {
      await onRefresh();
    } finally {
      overlayContext.stopLoader(onRemoveLoader);
      dismissModal();
    }
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, _objectSpread(_objectSpread({}, commonModalProps), {}, {
    "data-testid": "rm-member",
    textAlignCenter: false,
    onCloseButtonClick: onClose,
    onSecondaryButtonClick: onClose,
    onPrimaryButtonClick: handleSubmit(onRemove),
    content: hasAssignedRelationships ? /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Typography, {
        className: styles.paragraph,
        children: ["In order to remove", ' ', /*#__PURE__*/_jsx(Typography, {
          as: "span",
          weight: "normal",
          children: member.fullName()
        }), ", you need to select another team member to reassign all proposals and agreements under their name."]
      }), /*#__PURE__*/_jsx(Typography, {
        className: styles.paragraph,
        children: "Please select one from the list"
      }), /*#__PURE__*/_jsx(Controller, {
        name: "memberIdToReassign",
        control: control,
        rules: requiredValidation(),
        render: p => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
          className: styles.paragraph,
          width: 280,
          testid: "rm-member-reassign",
          label: "Select team member"
        }, connectControllerToTextField(p)), {}, {
          children: optionsToReassign.map(_ref3 => {
            let {
              id,
              text
            } = _ref3;
            return /*#__PURE__*/_jsx(MenuItem, {
              value: id,
              "data-testid": "rm-member-reassign-opt-".concat(id),
              children: text
            }, id);
          })
        }))
      })]
    }) : /*#__PURE__*/_jsxs(Typography, {
      children: ["Are you sure you want to remove", ' ', /*#__PURE__*/_jsx(Typography, {
        as: "span",
        weight: "normal",
        children: member.fullName()
      }), ' ', "from your team? Once removed they will no longer be able to access your business."]
    })
  }));
}